export default __webpack_public_path__ + "static/media/Foto-14.69e82ccb.png";